import { Component, Input } from '@angular/core';
import { SharedModule } from '../shared/shared.module';

@Component({
    selector: 'app-status-message',
    imports: [SharedModule],
    template: `
    <div class="status-message" >
      <mat-icon
        class="status-icon"
        [style.fontSize.px]="size "
        [style.width.px]="size "
        [style.height.px]="size "
        [style.color]="color">
        {{ icon }}
      </mat-icon>
      <h1 class="status-title">{{ title | translate }}</h1>
      @if (description) {
        <p class="status-description">{{ description  | translate }}</p>
      }
    </div>
    `,
    styles: [
        `
      .status-message {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
      }

      .status-title {
        font-weight: bold;

      }

      .status-description {
        color: gray;
      }
    `
    ]
})
export class StatusMessageComponent {
  @Input() icon!: string;
  @Input() title!: string;
  @Input() description?: string;
  @Input() size: number = 200;
  @Input() color: string = 'orange';
}
